(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["benefits-pdp"] && !window.DesignMode) return;
  try {
    
  var controller = new ScrollMagic.Controller();
$(".benefit-new__img").each(function() {
   var tlImg = new TimelineMax().from($(this).find("img"), 1, {
      yPercent: -100,
      transformOrigin: "top right",
      ease: Linear.easeNone
   });
   var sceneimg = new ScrollMagic.Scene({
      triggerElement: this,
      duration: 1000,
      triggerHook: 1
   })
      .setTween(tlImg)
      .addTo(controller);
});

("use strict");
// var SmoothScroll = (function() {
//    function e(e) {
//       var t = this;
//       (this._onResize = function(e) {
//          t.resizeRequest++,
//             t.requestId || (t.requestId = requestAnimationFrame(t._update));
//       }),
//          (this._onScroll = function(e) {
//             t.scrollRequest++,
//                t.requestId || (t.requestId = requestAnimationFrame(t._update));
//          }),
//          (this._update = function() {
//             var e = t.resizeRequest > 0,
//                s = window.pageYOffset;
//             if (e) {
//                var r = t.target.clientHeight;
//                (document.body.style.height = r + "px"),
//                   (t.scrollHeight = r),
//                   (t.viewHeight = window.innerHeight),
//                   (t.halfViewHeight = t.viewHeight / 2),
//                   (t.maxDistance = 2 * t.viewHeight),
//                   (t.resizeRequest = 0);
//             }
//             (t.endScroll = s),
//                (t.currentScroll += (s - t.currentScroll) * t.scrollEase),
//                (Math.abs(s - t.currentScroll) < t.endThreshold || e) &&
//                   ((t.currentScroll = s), (t.scrollRequest = 0));
//             var i = t.currentScroll + t.halfViewHeight;
//             t.target.style.transform =
//                "translate3d(0px,-" + t.currentScroll + "px,0px)";
           
//             for (var l = 0; l < t.scrollItems.length; l++) {
//                var n = t.scrollItems[l],
//                   a = i - n.top,
//                   o = a / t.maxDistance;
//                (n.endOffset = Math.round(t.maxOffset * n.depthRatio * o)),
//                   Math.abs(n.endOffset - n.currentOffset < t.endThreshold)
//                      ? (n.currentOffset = n.endOffset)
//                      : (n.currentOffset +=
//                           (n.endOffset - n.currentOffset) * t.scrollEase),
                 
//                   (n.target.style.transform =
//                      "translate3d(0px,-" + n.currentOffset + "px,0px)");
//             }
//             t.requestId =
//                t.scrollRequest > 0 ? requestAnimationFrame(t._update) : null;
//          }),
//          (this.target = e.target),
//          (this.scrollEase = null != e.scrollEase ? e.scrollEase : 0.1),
//          (this.maxOffset = null != e.maxOffset ? e.maxOffset : 500),
//          (this.endThreshold = 0.05),
//          (this.requestId = null),
//          (this.maxDepth = 10),
//          (this.viewHeight = 0),
//          (this.halfViewHeight = 0),
//          (this.maxDistance = 0),
//          (this.scrollHeight = 0),
//          (this.endScroll = 0),
//          (this.currentScroll = 0),
//          (this.resizeRequest = 1),
//          (this.scrollRequest = 0),
//          (this.scrollItems = []),
//          this.addItems(),
//          window.addEventListener("resize", this._onResize),
//          window.addEventListener("scroll", this._onScroll),
//          this._update();
//    }
//    return (
//       (e.prototype.addItems = function() {
//          this.scrollItems = [];
//          for (
//             var e = document.querySelectorAll("*[data-depth]"), t = 0;
//             t < e.length;
//             t++
//          ) {
//             var s = e[t],
//                r = +s.getAttribute("data-depth"),
//                i = s.getBoundingClientRect(),
//                l = {
//                   target: s,
//                   depth: r,
//                   top: i.top + window.pageYOffset,
//                   depthRatio: r / this.maxDepth,
//                   currentOffset: 0,
//                   endOffset: 0
//                };
//             this.scrollItems.push(l);
//          }
//          return this;
//       }),
//       e
//    );
// })();

var scroller = new SmoothScroll({
   target: document.querySelector("#scroll-container"), // element container to scroll
   scrollEase: 0.08, // scroll speed
   maxOffset: 1000
});


  } catch(e) { console.error(e); }
})();

})();
